<div class="cm-contenido-central">
  <mat-tab-group [selectedIndex]="activeTab" (selectedIndexChange)="onChangeTab($event)">
    <mat-tab label="Settings">
      <ng-template mat-tab-label>
        <mat-icon>settings</mat-icon>
      </ng-template>
      <div *ngIf="editMainContent" style="margin-top: 16px;">
        <form [formGroup]="eventoForm">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Tipo de evento</mat-label>
            <mat-select placeholder="Tipo de evento" formControlName="tipoEvento">
              <mat-optgroup *ngFor="let tipoEvento of tiposEvento" [label]="tipoEvento.nombre">
                <mat-option *ngFor="let categoria of tipoEvento.categorias" [value]="categoria.id">
                  {{categoria.nombre}}
                </mat-option>
              </mat-optgroup>
            </mat-select>
            <mat-error *ngIf="eventoForm.get('tipoEvento').hasError('required')">El tipo de evento es
              requerido.
            </mat-error>
          </mat-form-field>
          <div class="flex-wrap">
            <div class="inline-flex">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>Título</mat-label>
                <input matInput placeholder="Título" formControlName="nombre">
              </mat-form-field>
            </div>
            <ng-container *ngIf="_eventoUnidad.evento.categoriaID == 81">
              <div id="classroomshare"></div>
            </ng-container>
          </div>
          <div *ngIf="tareas$ | async as tareas" class="full-width">
            <mat-label><strong>Descripción</strong></mat-label>
            <div class="enunciado-ck-container">
              <!-- <ckeditor appCkeditorImageDelete name="descripcion" [formControl]="eventoForm.get('resumen')"
                [config]="{language: 'es', url: ckeditorImageEndPoint, token: userToken, refreshUrl: refreshUrl, refreshToken: refreshToken, origen: 'Unidad', store: 'Estudio'}"
                [editor]="inlineEditor">
              </ckeditor> -->
            </div>
          </div>
          <div *ngIf="_eventoUnidad.id > 0" style="margin-top: 24px;">
            <div class="mat-list">
              <h3 class="mat-h2">Materias</h3>
              <ng-container *ngIf="materiasPeriodo$ | async as materiasPeriodo">
                <ng-container *ngFor="let materiaPeriodo of materiasPeriodo">
                  <div class="fecha-materia-header">
                    <h4 class="mat-h2"> {{materiaPeriodo.nombreCompleto}}</h4>
                    <app-unidad-form-classroom-select *ngIf="courses$ | async as courses" [materia]="materiaPeriodo"
                      [actual]="materiaPeriodo.classroomCourseId" [courses]="courses" [editable]="true">
                    </app-unidad-form-classroom-select>
                    <!-- _eventoUnidad.evento.isEditable -->
                    <button mat-raised-button color="primary" (click)="agregarEventoMateria(materiaPeriodo.id)">
                      Agregar fecha
                    </button>
                  </div>
                  <ul *ngFor="let eventoMateria of _eventoUnidad.eventoMaterias">
                    <li *ngIf="eventoMateria.materiaCursoPeriodoID == materiaPeriodo.id"
                      [ngStyle]="{'color': eventoMateria.isCompletado ? 'green' : 'normal'}" class="class-date">
                      <div class="class-date__basicdata">
                        <mat-form-field appearance="standard">
                          <mat-label>Fecha</mat-label>
                          <input matInput placeholder="Fecha" [matDatepicker]="myDatepicker"
                            (focus)="myDatepicker.open()" (dateChange)="setDate(eventoMateria, materiaPeriodo, $event)"
                            [value]="eventoMateria.fechaAplicar">
                          <!--[(ngModel)]="eventoMateria.fechaAplicar"
                        [ngModelOptions]="{standalone: true}"-->
                          <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
                          <mat-datepicker #myDatepicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="standard">
                          <mat-label>Duración</mat-label>
                          <input matInput placeholder="Duración" [(ngModel)]="eventoMateria.duracion"
                            [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      </div>
                      <div class="class-date__classroom">
                        <div *ngIf="tareas$ | async as tareas">
                          <app-evento-form-classroom [evento]="eventoMateria"
                            [materia]="materiaPeriodo" [tareas]="tareas" [actual]="eventoMateria.courseWorkId"
                            [editable]="true" class="full-width"></app-evento-form-classroom>
                        </div>
                      </div>
                      <div class="class-date__tools">
                        <button mat-icon-button (click)="setEstadoMCP(eventoMateria, !eventoMateria.isCompletado)">
                          <mat-icon>check</mat-icon>
                        </button>
                        <button mat-icon-button (click)="eliminarEventoMateria(eventoMateria)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </li>
                  </ul>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <mat-divider></mat-divider>
          <p></p>
          <div *ngIf="_eventoUnidad.id > 0" style="margin-top: 24px;">
            <div class="mat-list">
              <h3 class="mat-h3">Recursos</h3>
              <button mat-raised-button color="primary" matTooltip="Agregar recursos de drive" (click)="loadGPicker()">
                Agregar recursos
              </button>
            </div>
            <div *ngIf="_eventoUnidad.recursos.length > 0" class="evento-adicionales__items">
              <!--<i class="material-icons" matTooltip="Recursos">attachment</i>-->
              <ul>
                <li class="evento-recurso flex-wrap" *ngFor="let recurso of _eventoUnidad.recursos">
                  <a href="{{recurso.url}}" target="_blank"><img src="{{recurso.iconUrl}}">
                    <span [ngStyle]="{'color': recurso.isVisibleToStudent ? 'green' : 'inherit'}">
                      {{recurso.nombre}}</span>
                  </a>
                  <span class="spacer"></span>
                  <button class="md-14" mat-icon-button matTooltip="Compartir con estudiantes."
                    (click)="estadoRecursoEstudiantes(recurso)">
                    <mat-icon class="md-14" [ngStyle]="{'color': recurso.isVisibleToStudent ? 'green' : 'inherit'}">
                      share
                    </mat-icon>
                  </button>
                  <button class="md-14" mat-icon-button matTooltip="Compartir con estudiantes."
                    (click)="eliminarRecurso(recurso)">
                    <mat-icon class="md-14">close
                    </mat-icon>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <mat-divider></mat-divider>
          <p></p>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Editores</mat-label>
            <mat-select placeholder="Editores" formControlName="profesores" multiple>
              <mat-option *ngFor="let profesor of profesores" [value]="profesor.id">
                {{profesor.nombresApellidos}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Áreas</mat-label>
            <mat-select placeholder="Áreas" formControlName="areas" multiple>
              <mat-optgroup *ngFor="let area of areas" [label]="area.nombre">
                <mat-option *ngFor="let materia of area.materias" [value]="materia.id">
                  {{materia.nombre}}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Cursos</mat-label>
            <mat-select placeholder="Cursos" formControlName="cursos" multiple>
              <mat-option *ngFor="let curso of cursosOpt" [value]="curso.id">{{curso.nombre}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Ámbitos</mat-label>
            <mat-select placeholder="Ámbitos" formControlName="ambitos" multiple>
              <mat-optgroup *ngFor="let ambito of ambitos" [label]="ambito.nombre">
                <mat-option *ngFor="let categoria of ambito.categorias" [value]="categoria.id">
                  {{categoria.nombre}}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Tags</mat-label>
            <mat-select placeholder="Tags" formControlName="tags" multiple>
              <mat-option *ngFor="let tag of tags" [value]="tag.id">{{tag.nombre}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </mat-tab>
    <mat-tab label="COMENTARIOS">
      <glm-comentarios [comentarios]="comentariosEvento" [targetID]="_eventoUnidad.id" [origen]="'unidadevento'">
      </glm-comentarios>
    </mat-tab>
  </mat-tab-group>
</div>
<div class="cm-botones" *ngIf="!guardando">
  <button style="margin-right: 4px;" mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="guardar()">Guardar</button>
</div>
<div class="cm-botones" *ngIf="guardando">
  <mat-progress-bar mode="query"></mat-progress-bar>
</div>
